import React from "react";
import MoreButton from "../Button/MoreButton";
import PlayButtonIcon from "../../assets/Play.svg";
import { motion } from "framer-motion";

function AboutUs() {
  return (
    <motion.div
      id="About-Us"
      className="bg-white pt-48 pb-36 px-10 sm:px-20 lg:px-32 flex flex-col lg:flex-row items-center justify-between gap-[56px]"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: "some" }}
    >
      {/* Text Content */}
      <motion.div
        className="w-full lg:w-[33vw]"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: "some" }}
      >
        <motion.span
          className="inter-black text-[#EEB762] text-2xl"
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { delay: 0.1 } },
          }}
        >
          ABOUT US
        </motion.span>

        <motion.h3
          className="text-[#1F1F1E] changa-one-regular text-4xl sm:text-6xl mb-6 mt-3"
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { delay: 0.3 } },
          }}
        >
          We Explore <br /> to Empower
        </motion.h3>

        <motion.p
          className="text-xl actor-regular text-[#1F1F1E] mb-8"
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { delay: 0.5 } },
          }}
        >
          Prime Steel Trading is a trusted Ethiopian supplier of high-quality
          steel products for the construction and manufacturing sectors.
          Established to meet the growing demand for reliable building
          materials, we specialize in supplying a wide range of steel products
          including Square Hollow Sections (SHS), Rectangular Hollow Sections
          (RHS), Angle Irons, U-Channels, Flat Irons, Round Bars, Round
          pipe,Sheet Metals, and Chequered Plates. With a strong commitment to
          quality, timely delivery, and customer satisfaction, Prime Steel
          Trading aims to be the preferred partner for contractors, developers,
          and manufacturers across Ethiopia.
        </motion.p>

        <motion.div
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { delay: 0.7 } },
          }}
        >
          <MoreButton title="READ MORE" />
        </motion.div>
      </motion.div>

      {/* Image */}
      <motion.div
        className="h-[45vw] lg:h-[25vw] w-full lg:w-[40vw] flex items-center justify-center shadow-xl rounded-xl relative cursor-pointer"
        variants={{
          hidden: { opacity: 0, x: 50 },
          visible: {
            opacity: 1,
            x: 0,
            transition: { delay: 0.9, duration: 0.6 },
          },
        }}
        onClick={() => {
          // window.open("https://www.youtube.com/watch?v=9kIzYEY9IKs", "_blank");
        }}
      >
        <img
          src={
            "https://images.unsplash.com/photo-1518709414768-a88981a4515d?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTV8fHN0ZWVsfGVufDB8MXwwfHx8MA%3D%3D"
          }
          alt={"About us"}
          className="object-cover h-full w-full rounded-xl"
        />
        <img
          className="h-[100px] w-[100px] object-contain absolute"
          src={PlayButtonIcon}
          alt="About us"
        />
      </motion.div>
    </motion.div>
  );
}

export default AboutUs;
